import React from "react";
import * as Styled from "./layout.styles";

export const AppFooter: React.FC = () => {
  return (
    <Styled.AppFooterWrapper>Powered by SPYDERRECEIPTS</Styled.AppFooterWrapper>
  );
};
